import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import { getMasterData, getPatientGuardianById, postPatientGuardianDetails } from '../../actions/PatientActions';
import { isValidNameWithSpace, normalizeMobile, renderAutoCompleteSingleSelect, renderCheckBox, renderTextField } from '../../../../components/reduxFields';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import validate from '../../validate';
import { CommonButton } from '../../../../components/buttons';
import { Scrollbars } from 'react-custom-scrollbars';
import SmallLoader from '../../../../img/small-loader.gif';


class PatientGuardianModal extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      open: true,
      patient_id: this.props.patient_id,
      patientMasterData: [],
      guardianId: props.guardianId,
    });

    /* document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
      }
    };*/

  }


  componentWillMount() {
    if (this.props.guardianId) {
      this.props.getPatientGuardianById(this.props.guardianId);
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.patientMasterData && this.props.patientMasterData !== nextProps.patientMasterData) {
      this.setState({
        // patientMasterData: nextProps.patientMasterData,
        // relationShip: nextProps.patientMasterData.masterRelationship,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleKeyDown = (e) => {
    if (e.keyCode === 27) {
      // console.log('You pressed the escape key!');
    }
  }
  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  handleOpen = () => {
    this.setState({ open: true,
    });

  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };


  handleSave=(formProps) => {
    formProps.patientID = this.state.patient_id;
    formProps.id = this.state.guardianId;
    this.props.postPatientGuardianDetails(formProps);
    this.setState({ open: false });
    this.props.closeDialog();
  };
  handleAddMore=(formProps) => {
    formProps.patientID = this.state.patient_id;
    formProps.id = this.state.guardianId;
    this.props.postPatientGuardianDetails(formProps);
    this.props.dispatch(reset('PatientGuardianModalForm'));
    this.setState({ open: true });
    // this.props.closeDialog();
  };

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let saveAndAddMore = <CommonButton primary={true} label="Save & Add More" onTouchTap={handleSubmit(this.handleAddMore.bind(this))}/>;
    let saveButton = <CommonButton className="mr-15" label="Save" onTouchTap = {handleSubmit(this.handleSave.bind(this))} primary={true}/>;
    let btns = [
      <CommonButton className="grey_btn mr-15" label="Cancel" onTouchTap={this.handleClose}/>,
      saveButton, this.props.guardianId ? '' : saveAndAddMore,
    ];
    const actions = [<div className="sm-btn-scroll"><Scrollbars>{btns} </Scrollbars></div>];
    let relationshipTypeObj = {};
    if (this.props.RelationshipID && this.props.patientMasterData && this.props.patientMasterData.masterRelationship) {
      this.props.patientMasterData.masterRelationship.map((masterObj, masterIndex) => {
        if (this.props.RelationshipID === masterObj.id) {
          relationshipTypeObj = masterObj;
        }
        return relationshipTypeObj;
      });
    }
    return (
      <div className="modalwindow">
        { this.state.open ?
          <Dialog className="custom_modal"
            title={this.state.guardianId ? 'Edit Guardian/Guarantor' : 'Add Guardian/Guarantor'}
            modal={false}
            open={this.state.open}
            autoScrollBodyContent={true}
            actions={actions}

            // onRequestClose={this.handleClose}
          >
            {this.renderLoading()}
            <div className="row" onKeyPress={this.handleKeyDown}>
              <div className="col-sm-12">
                <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.handleSave.bind(this))}>
                  <div className="row">
                    <div className="col-sm-4 require">
                      <Field
                        autoFocus={true}
                        name="guardianFirstName"
                        type="text"
                        maxLength="40"
                        normalize = {isValidNameWithSpace}
                        label="First Name"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-4">
                      <Field
                        name="guardianMiddleName"
                        type="text"
                        maxLength="40"
                        normalize = {isValidNameWithSpace}
                        label="Middle Name"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-4 require">
                      <Field
                        name="guardianLastName"
                        type="text"
                        maxLength="40"
                        normalize = {isValidNameWithSpace}
                        label="Last Name"
                        component={renderTextField} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <Field
                        name="guardianEmail"
                        type="text"
                        maxLength="40"
                        // normalize = {isValidNameWithSpace}
                        label="Email"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-4">
                      <Field
                        name="guardianHomePhone"
                        type="text"
                        maxLength="14"
                        label="Phone"
                        normalize={normalizeMobile}
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-4 mt-35">
                      <Field
                        name="isGuarantor"
                        label="Is Guarantor"
                        component={renderCheckBox} />
                    </div>
                  </div>
                  <div className ='row'>
                    <div className="col-sm-6 require mt-35">

                      <Field
                        name="relationshipID"
                        label="Relationship"
                        component={renderAutoCompleteSingleSelect}
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.relationShip}
                        openOnFocus={true}
                      />
                    </div>
                    {relationshipTypeObj && relationshipTypeObj.value && relationshipTypeObj.value.toUpperCase() === 'OTHER' ?
                      <div className="col-sm-6 require">
                        <Field
                          name="otherRelationshipName"
                          label="Other Relationship"
                          component={renderTextField}
                        />
                      </div>
                      : ''}
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null }
      </div>
    );
  }
}

const selector = formValueSelector('PatientGuardianModalForm');
const mapStateToProps = (state, ownProps) => {

  let initialValueData = null;
  if (ownProps.guardianId && state.patient.patientGuardianDetails && state.patient.patientGuardianDetails.data) {
    initialValueData = state.patient.patientGuardianDetails.data;
  }

  return {
    loading: state.patient.loading,
    initialValues: initialValueData,
    patientMasterData: state.patient.patientMasterData,
    // patientId: state.patient.patientId,
    RelationshipID: selector(state, 'relationshipID'),
    relationShip: state.patient.patientMasterData && state.patient.patientMasterData.masterRelationship ? state.patient.patientMasterData.masterRelationship : [],
  };
};
PatientGuardianModal = reduxForm({
  form: 'PatientGuardianModalForm',
  validate,
  enableReinitialize: true,
})(PatientGuardianModal);

export default connect(mapStateToProps, { getMasterData, postPatientGuardianDetails, getPatientGuardianById })(PatientGuardianModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/guardian/patient_guardian_form.js